module.exports = __webpack_public_path__ + "static/img/icon-7zip_filled.69f4a4ed.svg";